"use strict";

import React from "react";

class LoadingSpinner extends React.Component {
  static defaultProps = {
    spinnerClass: "loading-spinner",
  };

  render() {
    const { spinnerClass, ...other } = this.props;

    return (
      <svg
        version="1.1"
        {...other}
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 20 20"
        className={spinnerClass}
      >
        <path
          fill="#ffffff"
          d="M10,0C4.5,0,0.5,4.5,0.5,10c0,4.9,4.5,9,9.5,9c-4.4,0-8.5-4.2-8.5-9c0-4.4,4.1-8,8.5-8c0.6,0,1-0.4,1-1C11,0.4,10.6,0,10,0z"
        />
      </svg>
    );
  }
}

export default LoadingSpinner;
